import { Extension } from '@tiptap/core';

export const PlainTextDocument = Extension.create({
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => editor.commands.setHardBreak(),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Shift-Enter': () => true,
    };
  },
});
